import React from 'react';
import sha256 from 'crypto-js/sha256';
import CryptoJS from 'crypto-js';
import notifyHB from '../../config/notifyHB';
import { toast } from '@/components/toast/toast';
import { rawHttp } from '../../http';
import PdfDropzone from '@/components/pdf-drop-zone/pdf-drop-zone';
import endpointConfig from '@/config/endpointConfig';
import { readAndConvertToHex } from '@/utils/read-and-convert-to-hex';
import styles from './verify-document-upload.module.scss';

type VerifyDocumentProps = {
	nextStep: () => void;
	setDocumentName: (name: string) => void;
	setSignatureDate: (date: string) => void;
	setSignerCredentials: (credentials: string) => void;
	setBase64Hash: (hash: string) => void;
	setSignedCyberSign: (signed: boolean) => void;
};

const VerifyDocumentUpload: React.FC<VerifyDocumentProps> = ({
	nextStep,
	setDocumentName,
	setSignatureDate,
	setSignerCredentials,
	setBase64Hash,
	setSignedCyberSign,
}) => {
	const fileUpload = (file: File) => {
		setDocumentName(file.name);
		setSignatureDate('');
		setSignerCredentials('');
		setBase64Hash('');
		setSignedCyberSign(false);

		readAndConvertToHex(
			file,
			async (fileInHex) => {
				const hashed = sha256(CryptoJS.enc.Latin1.parse(fileInHex));
				try {
					const verifyResponse = await rawHttp.post(
						endpointConfig.docsVerify,
						{
							documentHash: hashed.toString(),
						},
					);
					setSignatureDate(verifyResponse.data.signatureDate);
					setSignerCredentials(verifyResponse.data.signerCredentials);
					setBase64Hash(verifyResponse.data.base64CAHash);

					if (verifyResponse.data.signedCyberSign) {
						setSignedCyberSign(true);
					} else {
						setSignedCyberSign(false);
					}
					nextStep();
				} catch (exception) {
					toast({ mode: 'destructive', description: 'Hubo un error validando el documento' });
					notifyHB(
						'verify-document',
						'VerifyDocumentUpload',
						exception,
					);
				}
			},
			(error) => {
				console.error(error);
				notifyHB('verify-document', 'VerifyDocumentUpload', error);
			},
		);
	};

	return (
		<div className={styles['verify-document-upload']}>
			<h3>Validar documento</h3>
			<PdfDropzone
				label="Sube el documento a validar"
				hint="Haz clic o arrastra y suelta para subir"
				onFileSelected={fileUpload}
			/>
		</div>
	);
};

export default VerifyDocumentUpload;
